// extracted by mini-css-extract-plugin
export default {"root":"app-portainer-components-form-components-SwitchField-Switch-module__root"};